import { useFeatureGate } from '@statsig/react-bindings';

import { getAppConfig } from './config';
import { wordpressUrlMigrationGate } from './statsig/gates';

const DIRECT_CONTACT_FORM_URL = 'https://growtherapy.jotform.com/grow-support/contact-us';

/**
 * Utility hook to get URLs for the contact us page and the direct contact form.
 *
 * @returns An object with the following properties:
 * - `pageUrl` - the default "contact us" page. Prefer this option for generally
 *   redirecting users (both providers and clients) to support.
 * - `directFormUrl` - the direct contact form. Use this for especially
 *   time-sensitive (e.g. session-blocking) needs or unauthenticated clients who
 *   may not be able to access their client portal.
 */
export function useContactUs() {
  const marketplaceOrigin = getAppConfig().marketplaceOrigin;

  const { value: wordpressUrlMigration } = useFeatureGate(wordpressUrlMigrationGate);
  const contactUsUrlPath = wordpressUrlMigration ? 'contact-us' : 'wp/contact-us';

  return {
    pageUrl: `${marketplaceOrigin}/${contactUsUrlPath}`,
    directFormUrl: DIRECT_CONTACT_FORM_URL,
  };
}
